import { render, staticRenderFns } from "./Dashboard_Brand_Landing.vue?vue&type=template&id=0b74444f&scoped=true&"
import script from "./Dashboard_Brand_Landing.vue?vue&type=script&lang=js&"
export * from "./Dashboard_Brand_Landing.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_Brand_Landing.vue?vue&type=style&index=0&id=0b74444f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74444f",
  null
  
)

export default component.exports